import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { ApiResponse } from "../models/PesslModuleModels";

export default class PesslModuleApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getDiseaseInfo(pkcuaa: number, lotId: number, cycle: string): Promise<{ data?: ApiResponse; error: string }> {
        const date = new Date();

        const toMonth = (date.getMonth() + 1).toLocaleString("it-IT", { minimumIntegerDigits: 2 });
        const toDay = (date.getDate()).toLocaleString("it-IT", { minimumIntegerDigits: 2 });
        const toHours = (date.getHours()).toLocaleString("it-IT", { minimumIntegerDigits: 2 });

        const to = `${date.getFullYear()}-${toMonth}-${toDay}T${toHours}:00:00Z`;


        const fromDate = new Date();

        fromDate.setHours(date.getHours() - 48);

        const fromMonth = (fromDate.getMonth() + 1).toLocaleString("it-IT", { minimumIntegerDigits: 2 });
        const fromDay = (fromDate.getDate()).toLocaleString("it-IT", { minimumIntegerDigits: 2 });
        const fromHours = (fromDate.getHours()).toLocaleString("it-IT", { minimumIntegerDigits: 2 });

        const from = `${fromDate.getFullYear()}-${fromMonth}-${fromDay}T${fromHours}:00:00Z`;


        const linkedStationId = await this.getIdFromLinkedStation(pkcuaa, lotId);

        if (linkedStationId == "no-linked-stations") {
            return { data: undefined, error: "no-linked-stations" };
        }

        const { isPesslDisease, idStation } = await this.checkSensorType(pkcuaa, linkedStationId);

        if (!isPesslDisease) {
            return { data: undefined, error: "sensor-type-no-pessl" };
        }

        const { data: light } = await this.http.get(`/sensor-x/api/v1/farm/${pkcuaa}/stations/${idStation}/sensors/Viticulture-GrapeVine-DownyMildew-${cycle}@Weak%20Infection/data?from=${from}&to=${to}`);

        const { data: moderate } = await this.http.get(`/sensor-x/api/v1/farm/${pkcuaa}/stations/${idStation}/sensors/Viticulture-GrapeVine-DownyMildew-PrimaryCycle@Moderate%20Infection/data?from=${from}&to=${to}`);

        const { data: severe } = await this.http.get(`/sensor-x/api/v1/farm/${pkcuaa}/stations/${idStation}/sensors/Viticulture-GrapeVine-DownyMildew-PrimaryCycle@Severe%20Infection/data?from=${from}&to=${to}`);

        const returnVal = {
            light: light.results,
            moderate: moderate.results,
            severe: severe.results
        };

        return { data: returnVal, error: "" };
    }

    public async getIdFromLinkedStation(farmId: number, lotId: number): Promise<string> {
        const res = await this.http.get(`/iot/api/v1/farm/${farmId}/plots/${lotId}/stations`);

        return (res.status == 200 && res.data && res.data.length > 0) ? res.data[0] : "no-linked-stations";
    }

    public async checkSensorType(farmId: number, stationId: string): Promise<{ isPesslDisease: boolean; idStation: string }> {
        const res = await this.http.get(`/sensor-x/api/v1/farm/${farmId}/stations/${stationId}/sensors`);

        let toReturn = false;

        if (res.status == 200 && res.data.results && res.data.results.length > 0) {
            toReturn = res.data.backendStatus.ok.includes("pessl");
        }

        return {
            isPesslDisease: toReturn,
            idStation: res.data && res.data.results.length > 0 ? res.data.results.filter((el: any) => el.stationId.split("@")[2] == "pessl")[0]?.stationId : ""
        };
    }
}
